import Model from '../../framework/model.js';
import Utils from '../../framework/utils.js';
import JobLocationModel from './job-location-model.js';

const defaults = {
  options: {
    all: {
      locations: [],
      employeeType: [],
      department: [],
      brand: []
    },
    displayed: {
      locations: [],
      employeeType: [],
      department: [],
      brand: []
    }
  },

  selectedFilter: {
    location: [],
    employeeType: [],
    department: [],
    brand: [],
    keyword: null
  },

  currentFilter: {
    location: [],
    employeeType: [],
    department: [],
    brand: [],
    keyword: null
  }
}

export default class FilterModel extends Model {
  constructor(data = {}) {
    super({data: data, defaults: defaults})
  }

  parsePost(post) {
    if (!this.get('options.all.employeeType').includes(post.getEmployeeTypeLabel())) this.get('options.all.employeeType').push(post.getEmployeeTypeLabel());
    if (!this.get('options.all.department').includes(post.getDepartmentLabel())) this.get('options.all.department').push(post.getDepartmentLabel());
    if (!this.get('options.all.brand').includes(post.getBrandLabel())) this.get('options.all.brand').push(post.getBrandLabel());
  }

  parseLocation(jobLoc) {
    this.get('options.all.locations').push(jobLoc);
  }

  sortFilters() {
    // sort locations by their id, which should be {country code}_{region}_{city}
    this.get('options.all.locations').sort((a, b) => {
      if (a.get('id') == JobLocationModel.REMOTE_ID) return -1;
      if (b.get('id') == JobLocationModel.REMOTE_ID) return 1;

      if (a.get('country') == b.get('country') || (a.get('country') != 'US' && b.get('country') != 'US')) {
        return Utils.sortValue(a.get('id'), b.get('id'))
      } else {
        return a.get('country') == 'US' ? -1 : 1;
      }
    });

    // ensure alphabetical ordering of other filter values
    this.get('options.all.employeeType').sort();
    this.get('options.all.department').sort();
    this.get('options.all.brand').sort();

    this.set('options.displayed.locations', this.get('options.all.locations'));
    this.set('options.displayed.employeeType', this.get('options.all.employeeType'));
    this.set('options.displayed.department', this.get('options.all.department'));
    this.set('options.displayed.brand', this.get('options.all.brand'));
  }

  // `checkPost(post)`
  //
  // Returns boolean whether the given post matches the current filter
  
  checkPost(post, filter = null) {
    if (filter == null) filter = this.get('currentFilter')
    let matchKeyword = false;
    let keywordBlob = post.getKeywordBlob().toLowerCase();
    if (!Utils.isEmpty(filter.keyword)) {
      let terms = filter.keyword.split(' ');
      matchKeyword = terms.reduce((net, term) => keywordBlob.includes(term.toLowerCase()) && net, true)
    } else {
      matchKeyword = true;
    }

    return (Utils.isEmpty(filter.location) || filter.location.map((loc) => loc.matchPost(post)).includes(true)) &&
      (Utils.isEmpty(filter.employeeType) || filter.employeeType.includes(post.getEmployeeTypeLabel())) &&
      (Utils.isEmpty(filter.department) || filter.department.includes(post.getDepartmentLabel())) &&
      (Utils.isEmpty(filter.brand) || filter.brand.includes(post.getBrandLabel())) &&
      matchKeyword;
  }

  selectFilter(filter, posts = null) {
    if (filter.location && filter.location.length)
      filter.location = filter.location.map((locId) => this.get('options.all.locations').find((a) => a.get('id') == locId));

    this.set('selectedFilter', filter)

    this.set('options.displayed', {
      locations: this.getFilteredFilters(filter, 'location', this.get('options.all.locations'), posts, (p) => p.get('jobLocation.id'), (a) => a.get('id')),
      employeeType: this.getFilteredFilters(filter, 'employeeType', this.get('options.all.employeeType'), posts, (p) => p.getEmployeeTypeLabel(), (a) => a),
      department: this.getFilteredFilters(filter, 'department', this.get('options.all.department'), posts, (p) => p.getDepartmentLabel(), (a) => a),
      brand: this.getFilteredFilters(filter, 'brand', this.get('options.all.brand'), posts, (p) => p.getBrandLabel(), (a) => a)
    })
  }

  getFilteredFilters(selectedFilter, filterName, filterList, posts, postValueFn, filterValueFn) {
    let tempFilter = Utils.deepClone(selectedFilter);
    tempFilter[filterName] = null;
    if (tempFilter.location) {
      tempFilter.location = this.get('options.all.locations').filter((a) => tempFilter.location.map((loc) => loc._data.id).includes(a.get('id')))
    }
    let ret = filterList.filter((a) => {
      return posts && posts.length ? posts.filter((p) => this.checkPost(p, tempFilter)).map(postValueFn).includes(filterValueFn(a)) : true
    })
    return ret;
  }

  setLocationByName(locationName) {
    let location = this.get('options.all.locations').find((a) => a.get('name') == locationName);
    this.set('selectedFilter', {
      location: location,
      employeeType: null,
      department: null,
      brand: null,
      keyword: null
    });
    this.set('currentFilter', {
      location: location,
      employeeType: null,
      department: null,
      brand: null,
      keyword: null
    }, true);
  }

  setLocationById(locationId, posts = []) {
    let location = this.get('options.all.locations').find((a) => a.get('id') == locationId);
    this.selectFilter({
      location: [locationId],
      employeeType: [],
      department: [],
      brand: [],
      keyword: null
    }, posts);
    this.set('currentFilter', {
      location: [location],
      employeeType: [],
      department: [],
      brand: [],
      keyword: null
    }, true);
  }

  setFilter(filters, posts = null) {
    this.selectFilter(filters, posts);
    this.set('currentFilter', filters);
  }

  reset() {
    this.selectFilter(Utils.deepClone(defaults.selectedFilter));
    this.set('currentFilter', Utils.deepClone(defaults.currentFilter));
  }
}